var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import List from "../../home/search/list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";
export var ReportsListItem = function (_a) {
    var records = _a.records, _b = _a.perPage, perPage = _b === void 0 ? 5 : _b, _c = _a.isSearch, isSearch = _c === void 0 ? false : _c, columns = _a.columns, link = _a.link, group = _a.group;
    var _d = useState(true), open = _d[0], setOpen = _d[1];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "relative mr-2" }, { children: [group !== "" && (_jsx(_Fragment, { children: _jsxs("button", __assign({ onClick: function () {
                            setOpen(!open);
                        }, className: "my-2" }, { children: [_jsx("span", { children: !open ? (_jsx(FontAwesomeIcon, { icon: faChevronDown })) : (_jsx(FontAwesomeIcon, { icon: faChevronUp })) }), _jsx("label", __assign({ className: "text-bold uppercase ml-2" }, { children: group }))] })) })), _jsx("div", __assign({ className: "bg-gray-50" }, { children: open && _jsx(List, { record: records !== null && records !== void 0 ? records : [], perPage: 10, isSearch: false, columns: columns, link: link }) }))] })) }));
};
